module.exports = __webpack_public_path__ + "img/hipaa-150.d0fb2d93.png";